// extracted by mini-css-extract-plugin
export default {"file_item":"selected-files_file_item__vMZB8"};